import clsx from 'clsx';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import React, { useEffect, useState } from 'react';

import { eraseStroke } from '../../../../../../../utils/erase';

let canvas = null;
function EraserButton(props) {
  const location = useLocation();
  const [isDrawing, setDrawing] = useState(false);
  const notepad = useSelector(state => state.notepad);
  // const params = useParams();

  useEffect(() => {
    canvas = { ...notepad };
  }, [notepad]);

  useEffect(() => {
    let isComponentMounted = true

    document.getElementById('mid_area').addEventListener('touchstart', (e) => {
      if (isComponentMounted) setDrawing(true);
    });

    window.addEventListener('touchend', e => {
      if (isDrawing === true) {
        if (isComponentMounted) setDrawing(false);

        const dom = document.getElementById('mid_area');
        if (dom) {
          dom.removeEventListener("touchmove", eraseEvent)
          dom.removeEventListener("click", eraseEvent)
        }
      }
    });

    return () => {
      isComponentMounted = false;
    }
  }, [isDrawing, canvas, notepad.isErase]);

  useEffect(() => {
    if (!notepad.isErase) return;
    if (!isDrawing) return;

    document.getElementById('mid_area').addEventListener("touchmove", eraseEvent);
    document.getElementById('mid_area').addEventListener("click", eraseEvent);
  }, [notepad.isErase, isDrawing, canvas]);

  const eraseEvent = (e) => {
    if (isDrawing) eraseStroke(e, canvas.canvasDraw);
  };
  
  return (
    <div className="pos_rgt" style={{ zIndex: 16 }}>
      <button 
        className={clsx(
          "bg_wht pen", 
          location.pathname.indexOf('aiDiagnosisTest') > -1 ? 'grn' : 'blue',
          notepad.isErase ? 'off' : 'on'
        )}
        onClick={() => props.onErase(false)}
      />
      <button 
        className={clsx(
          "bg_wht eraser", 
          location.pathname.indexOf('aiDiagnosisTest') > -1 ? 'grn' : 'blue',
          notepad.isErase ? 'on' : 'off'
        )} 
        onClick={() => props.onErase(true)}
      />
    </div>
  );
}

export default EraserButton;